// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"3d23c979","285":"4d3fdd7d","356":"50c134bf","579":"83a34759","787":"03b04ca7","820":"f66fd231","853":"6a3e9b94","939":"0b974b4a","952":"74b4ac07"}[chunkId] + ".chunk.js";
};